import React from 'react';
import '../css/about.css';

export default function About() {
    return (
        <div className="aboutContainer">
            <div className="profileSection">
                <div className="contactHeader">
                    <h1 className="contactInfoHeader">Kontaktinė informacija</h1>
                </div>
                <div className="contactInfo">
                    <div className='regularContacts gridItem'>
                        <p>Susisiekimo būdai</p>
                        <p><strong>Telefono numeris:</strong> +370 693 55991</p>
                        <p><strong>Elektronins Paštas:</strong> <a href="mailto:finansailab@gmail.com">finansailab@gmail.com</a></p>
                        <p><strong>Tinklapis:</strong> <a href="https://www.finansailab.lt" target="_blank" rel="noopener noreferrer">www.finansailab.lt</a></p>
                    </div>
                    <div className="socials gridItem">
                        <p>Socialiniai Tinklai</p>
                        <a href="https://www.facebook.com/profile.php?id=100076323362434" target="_blank" rel="noreferrer">Facebook</a>
                        <a href="https://x.com/FinansaiL?t=8n5aoXrignp5XjJGsTePaA&s=07" target="_blank" rel="noreferrer">X</a>
                        <a href="https://www.youtube.com/@finansailab" target="_blank" rel="noreferrer">YouTube</a>
                        <a href="https://instagram.com/finansailab" target="_blank" rel="noreferrer">Instagram</a>
                    </div>
                </div>
            </div>
        </div>
    );
}